import { createContext, useContext } from 'react';

export interface SwitchContextValue {
  /**
   * The id the label part takes, so the control can point `aria-labelledby` at
   * it. `role="switch"` is not named by its content, so the text alone is not
   * enough.
   */
  labelId: string;
  /** The label reports itself, because the control renders before its parts. */
  registerLabel(): () => void;
}

export const SwitchContext = createContext<SwitchContextValue | null>(null);

export function useSwitchContext(): SwitchContextValue {
  const context = useContext(SwitchContext);

  if (!context) {
    throw new Error('Switch parts must be rendered inside a <Switch>.');
  }

  return context;
}
